import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { Subscription } from 'rxjs';
import { AdminContextService } from '../../../../../common/services/admin.context.service';
import { TickerTableDataSource } from '../main-table-content-v2/TickerTableDataSource';
import { MenuDTO, TickerConfigDTO } from '../../../../../system/system-dtos';
import { MenuUtils } from '../../../../../common/utils/menu-utils';
import { MaintainService } from '../../../maintain/maintain.service';
import { QuickFilterDTO } from '../../../../data-type-widgets/data-type/lottomart/model/lottomart-model';

@Component({
  selector: 'app-table-filter-v2',
  templateUrl: './table-filter-v2.component.html',
  styleUrls: ['./table-filter-v2.component.scss'],
  standalone: false,
})
export class TableFilterV2Component implements OnInit, OnDestroy {
  public static TICKER_COHORT_FILTER_LOCAL_STORAGE_KEY = 'tickerCohortFilter';

  ds: TickerTableDataSource;
  filterValue: string = '';
  locksOnly: boolean;
  selectedCohortOnly: boolean;
  private cohortSubscription: Subscription;
  private currentCohortId: number;
  _menuConfig: MenuDTO;
  elasticFilterGroup: string;
  elasticFilters: QuickFilterDTO[];
  elasticFilter: boolean = false;

  constructor(
    private adminContextService: AdminContextService,
    private maintainService: MaintainService,
    private router: Router
  ) {}

  @Input() set dataSource(value: TickerTableDataSource) {
    this.ds = value;
    if (this.currentCohortId && this.cohortSubscription) {
      this.updateDataSource();
    }
  }
  @Input() set menuConfig(value: MenuDTO) {
    this._menuConfig = value;
    this.initialiseQuickFilter();
  }

  ngOnInit(): void {
    this.selectedCohortOnly = /true/i.test(
      localStorage.getItem(TableFilterV2Component.TICKER_COHORT_FILTER_LOCAL_STORAGE_KEY)
    );
    this.cohortSubscription = this.adminContextService
      .getCohortWatcher()
      .pipe(filter((c) => !!c))
      .subscribe((c) => {
        this.currentCohortId = c.id;
        if (this.ds) {
          this.updateDataSource();
        }
      });
  }

  ngOnDestroy() {
    this.cohortSubscription.unsubscribe();
  }

  onKeyUp($event: KeyboardEvent) {
    this.updateDataSource();
  }

  onToggleSwitch($event: MatSlideToggleChange) {
    this.updateDataSource();
  }

  updateDataSource() {
    this.ds.filterSubject.next({
      text: this.filterValue,
      locksOnly: this.locksOnly,
      cohortId: this.selectedCohortOnly ? this.currentCohortId : null,
    });
  }

  selectedCohortToggleSwitch($event: MatSlideToggleChange) {
    localStorage.setItem(TableFilterV2Component.TICKER_COHORT_FILTER_LOCAL_STORAGE_KEY, $event.checked.toString());
    this.onToggleSwitch($event);
  }

  private initialiseQuickFilter(): void {
    if (this._menuConfig?.entityGroup?.dataSources === undefined) {
      return;
    }

    for (let ds of this._menuConfig.entityGroup.dataSources) {
      if (ds.type === 'TICKER') {
        let def: TickerConfigDTO = ds.definition as TickerConfigDTO;
        this.elasticFilterGroup = def.elasticFilterGroup;
        break;
      }
    }
    if (this.elasticFilterGroup != undefined) {
      this.maintainService.getElasticFilterForGroup(this.elasticFilterGroup).subscribe((d) => {
        d.forEach((f) => {
          f.ngStyle = f.ngStyle ? JSON.parse(f.ngStyle) : undefined;
        });
        this.elasticFilters = d;
        this.elasticFilter = true;
        this.removeAdyenFromMethods();
      });
    }
  }

  removeAdyenFromMethods(): void {
    const currentUrl = this.router.url;
    if (currentUrl.includes('withdraw')) {
      this.elasticFilters = this.elasticFilters.filter((item) => item.label !== 'ADYEN');
    }
  }

  quickFilterClicked(filterDef: QuickFilterDTO): void {
    let value = this.filterValue;
    if (value === undefined || value === '') {
      value = filterDef.queryString;
    } else {
      value += ',' + filterDef.queryString;
    }
    this.filterValue = value;
    this.updateDataSource();
  }
}
